module.exports = "images/cross.c6da4a05.png";